import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import spacing from '@honeybook/hbui/dist/styles/spacing';
import useAnalytics from '../../../../../common/useAnalytics';
import { AnalyticsEvents } from '../../../../../services/analytics/analytics-events';
import { AutomationCombinedTypes } from '../../../AutomationsEnums';
import { useRootStore } from '~/stores/useRootStore';
import HBDropdownField from '@honeybook/hbui/dist/components/HBDropdownField/HBDropdownField';
import { IUserPipelineStageResponse } from '~/types/server.types';
import { useTranslation } from 'react-i18next';
import { NAMESPACES } from '~/i18n/namespaces';

interface PipelineStageSelectProps {
    onSelectStage: (value: string) => void;
    type: AutomationCombinedTypes;
    options: IUserPipelineStageResponse[];
}

const PipelineStageSelect = ({
    onSelectStage,
    options,
    type
}: PipelineStageSelectProps) => {
    const {
        automationUiStore: {
            selectedStep: { combinedType, stage }
        }
    } = useRootStore();

    const { track } = useAnalytics();
    const { t } = useTranslation(NAMESPACES.PIPELINE, {
        keyPrefix: 'customize'
    });

    const pipelineOptions = options.map(option => {
        return {
            // @ts-ignore
            label: t(`fixed_names.${option.name}`, option.name),
            value: option._id
        };
    });

    const handleSelect = selectedStage => {
        track(AnalyticsEvents.AutomationsSideBarOpenActionDropdown, {
            action: 'click',
            origin: combinedType,
            type
        });
        onSelectStage(selectedStage);
    };

    return (
        <ButtonContainer>
            <StyledTitle type="Body6DarkPrimary">Stages</StyledTitle>
            <HBDropdownField
                placeholder="Select destination stage"
                id="pipeline_stage_select_dropdown"
                onChange={selectedStage => handleSelect(selectedStage)}
                options={pipelineOptions}
                value={stage}
            />
        </ButtonContainer>
    );
};

export default observer(PipelineStageSelect);

const ButtonContainer = styled.div`
    &:not(:last-of-type) {
        margin-bottom: ${spacing[20]};
    }

    padding: ${spacing[12]} 0;

    &:last-of-type {
        padding-bottom: ${spacing[4]};
    }
`;

const StyledTitle = styled(HBText)`
    display: block;
    padding-bottom: 8px;
`;
